import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	/**commit mutations*/
	//메인화면 초기화
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	//팝업화면 초기화
	setPopupStateInit_({ commit }) {
		commit(types.POPUP_STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setSelectedParam_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setpvoPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value, gubun: 'pvoPagingInfo' });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				const list = [];
				val.length && val.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				commit(types.DEFAULT_ASSIGN, { key, value: list });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 측정기 교정업체 셀렉트박스 조회
	async getMmcInstList_({ commit }) {
		try {
			const { header, body } = await api.getMmcInstList();
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key: 'calInstCdList', value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	// 조회버튼 클릭시
	async getMesList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getMesList({ searchParams, pagingInfo });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async saveCset_({ state }) {
		try {
			const sendList = state.csetResultList.map(row => {
				return { mesEqipNo: row.mesEqipNo, calCmplDd: row.calCmplDd };
			});
			const data = await api.saveCset(sendList);
			return data.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error.header || error;
		}
	}
};
